(function() {
    'use strict';
    /*eslint-disable dot-notation */

    angular
        .module('spidwebApp')
        .provider('envService', envServiceProvider);


    function envServiceProvider () {

        this.$get = angular.noop;

        var currentEnvironment;

        var service = {
            $get: function () {
                return service;
            },
            properties: envProperties,
            wediaProperties: wediaEnvironments,
            getProperty: function (key) {
                return service.properties[key];
            },
            getCurrentEnvironmentProperty: function (key) {
                return service.properties[service.getCurrentEnvironment()][key];
            },
            setCurrentEnvironment: function (env) {
                currentEnvironment = env;
            },
            getCurrentEnvironment: function () {
                return currentEnvironment;
            },
            getVersion: function () {
                return service.properties['version'];
            },
            getUrl: function (key) {
                return service.properties['urls'][key];
            },
            getGAAccount: function () {
                return service.properties[service.getCurrentEnvironment()]['GAAccount'];
            },
            getBeamerAccount: function () {
                return service.properties[service.getCurrentEnvironment()]['beamerAccount'];
            },
            getContentsURL: function () {
                return service.properties[service.getCurrentEnvironment()]['contentsURL'];
            },
            getServerContext: function () {
                return service.properties[service.getCurrentEnvironment()]['serverContext'];
            },
            getServerApiContext: function () {
                return this.getServerContext() + service.properties[service.getCurrentEnvironment()]['serverApiContext'] + '/';
            },
            getAuthUser: function () {
                return this.getWebAppContextUrl() + service.getUrl('authUser');
            },
            getAuthorizeUrl: function () {
                return this.getWebAppContextUrl() + service.getUrl('authorizeUrl');
            },
            getAuthTokensUrl: function () {
                return this.getWebAppContextUrl() + service.getUrl('authTokensUrl');
            },
            getRefreshTokensUrl: function () {
                return this.getWebAppContextUrl() + service.getUrl('refreshTokensUrl');
            },
            getUserContext: function () {
                return this.getWebAppContextUrl() + 'user';
            },
            getBaseUrl: function () {
                return service.properties[service.getCurrentEnvironment()]['base'];
            },
            getTreeUrl: function () {
                return this.getWebAppContextUrl() + service.getUrl('tree');
            },
            getUrlCountriesListUrl: function () {
                return service.getCountryContext() + '/locales';
            },
            getUrlLanguageDependencies: function () {
                return service.getCountryContext() + '/languageForDisplay';
            },
            getUrlRightToLeftLocale: function () {
                return this.getWebAppContextUrl() + service.getUrl('urlRightToLeftLocale');
            },
            getGenderUrl: function () {
                return service.getOfferDatasContext() + '/genders';
            },
            getProductNaturesUrl: function () {
                return service.getOfferDatasContext() + '/productNatures';
            },
            getSuperModelModifyProductNatureURL: function () {
                return this.getWebAppContextUrl() + service.getUrl('superModelEditProductNature');
            },
            getOfferDatasContext: function () {
                return this.getWebAppContextUrl() + service.getUrl('offerdatas');
            },
            getTranslationUrl: function () {
                return this.getWebAppContextUrl() + service.getUrl('translation');
            },
            getTranslationV2Url: function () {
                return this.getWebAppContextUrl() + service.getUrl('translation') + '/v2';
            },
            getBrandUniverseUrl: function () {
                return this.getWebAppContextUrl() + service.getUrl('brandUniverse');
            },
            getSportsUrl: function () {
                return service.getOfferDatasContext() + '/sports';
            },
            getMassActionsContext: function () {
                return this.getWebAppContextUrl() + service.getUrl('massActionsContext');
            },
            getReconductionModelUrl: function (modelId, locale) {
                return service.getModelsContext() + '/' + modelId + '/' + locale + '/reconduction';
            },
            getPixlUrl: function () {
                return this.getWebAppContextUrl() + 'pixl';
            },
            getParametersURL: function () {
                return this.getWebAppContextUrl() + service.getUrl('parametersContext');
            },
            getFluxContext: function () {
                return this.getWebAppContextUrl() + service.getUrl('fluxContext');
            },
            getTranslationMappingsContext: function () {
                return this.getWebAppContextUrl() + service.getUrl('translationMappingsContext');
            },
            getLogoutUrl: function () {
                return service.getBaseUrl() + service.getServerContext() + service.getUrl('logout');
            },
            getRightsManagementLink: function () {
                return service.getBaseUrl() + service.getServerContext() + service.getUrl('rightsManagementLink');
            },
            getUrlBrandLdap: function () {
                return this.getWebAppContextUrl() + service.getUrl('brandLdap');
            },
            getCountryContext: function () {
                return this.getWebAppContextUrl() + service.getUrl('countryContext');
            },
            getTranslationJobUrl: function (alfrescoId) {
                return service.getTranslationJobsContext() + '/' + alfrescoId;
            },
            getMassRepublicationtUrl: function (modelCode) {
                return service.getModelsContext() + '/' + modelCode + '/republish';
            },
            getDuplicateMediasUrl: function (modelNodeId) {
                return service.getModelsContext() + '/' + modelNodeId + '/duplicateMedias';
            },
            getArticlesByModelUrl: function (modelCode) {
                return this.getWebAppContextUrl() + service.getUrl('modelsContext') + '/' + modelCode + '/articles';
            },
            getSizeGridUpdateUrl: function (modelCode) {
                return this.getWebAppContextUrl() + service.getUrl('modelsContext') + '/' + modelCode + '/articles/sizegrid';
            },
            getBrightcoveUrl: function () {
                return service.getUrl('brightcoveUrl');
            },
            getNotationUnitsUrl: function () {
                return this.getWebAppContextUrl() + service.getUrl('notationUnits');
            },
            getMaterialsUrl: function () {
                return service.getOfferDatasContext() + '/compositions';
            },
            getProductPartsUrl: function () {
                return service.getOfferDatasContext() + '/partsOfProduct';
            },
            getCareInstructionsUrl: function () {
                return service.getOfferDatasContext() + '/careInstructions';
            },
            getCareSymbolsUrl: function () {
                return service.getOfferDatasContext() + '/careSymbols';
            },
            getWarningsUrl: function () {
                return service.getOfferDatasContext() + '/warnings';
            },
            getZdUrl: function () {
                return this.getWebAppContextUrl() + service.getUrl('zd');
            },
            getCartContent: function () {
                return this.getWediaEnvironmentProperty('cartContent');
            },
            getCdnBaseUrl: function () {
                return this.getWediaEnvironmentProperty('cdnBaseUrl');
            },
            getVideoAvailableLanguages: function () {
                return this.getWebAppContextUrl() + service.getUrl('videoAvailableLanguagesURL');
            },
            getWediaEnvironmentProperty: function(wediaProperty) {
                var wediaEnvironment = this.getCurrentEnvironmentProperty('wediaEnvironment');
                return service.wediaProperties[wediaEnvironment][wediaProperty];
            },
            getSeasonsContext: function() {
                return this.getWebAppContextUrl() + service.getUrl('seasonsContext');
            },
            getBrandURL: function() {
                return this.getWebAppContextUrl() + service.getUrl('brandContext');
            },
            getModelsContext: function() {
                return this.getWebAppContextUrl() + service.getUrl('modelsContext');
            },
            getModelSeasonsContext: function() {
                return this.getWebAppContextUrl() + service.getUrl('modelSeasonsContext');
            },
            getSuperModelsContext: function() {
                return this.getWebAppContextUrl() + service.getUrl('superModelsContext');
            },
            getProductCardContext: function() {
                return this.getWebAppContextUrl() + service.getUrl('productCardContext');
            },
            getSuperModelSeasonsContext: function() {
                return this.getWebAppContextUrl() + service.getUrl('superModelSeasonsContext');
            },
            getSuperModelSeasonEventsContext: function() {
                return this.getWebAppContextUrl() + service.getUrl('superModelSeasonEvents');
            },
            getUserBenefitContext: function() {
                return this.getWebAppContextUrl() + service.getUrl('userBenefitContext');
            },
            getTranslationJobsContext: function() {
                return this.getWebAppContextUrl() + service.getUrl('translationJobsContext');
            },
            getTransdiagTranslationStateUrl: function (modelCode, dateSale, language) {
                const transdiagBaseUrl = service.properties[service.getCurrentEnvironment()]['transdiagBaseUrl'];
                return transdiagBaseUrl + service.getUrl('transdiagTranslationState') + '?modelCode=' + modelCode + '&dateSale='
                                + dateSale + '&language=' + language + '&closedProjects=true' + '&submit=true';
            },
            getAllSeasonByCodeModelUrl: function () {
                return service.getProductCardContext() ;
            },
            getPropagationContext: function() {
                return this.getWebAppContextUrl() + service.getUrl('propagationContext');
            },
            getVersionsContext: function() {
                return this.getWebAppContextUrl() + service.getUrl('versionsContext');
            },
            getProductBriefReferenceUrl: function() {
                return service.getCurrentEnvironmentProperty('productBriefBaseUrl') + service.getUrl('productBriefReferenceEndpoint');
            },
            getSpoUpdateSmUrl: function() {
                return service.getCurrentEnvironmentProperty('spoBaseUrl') + service.getUrl('spoUpdateSmEndpoint');
            },
            getSuperModelTimelineUrl: function() {
                return this.getWebAppContextUrl() + service.getUrl('timeline') + '/superModels/:code';
            },
            getInvalidUrl: function() {
                return this.getWebAppContextUrl() + 'ERROR_500';
            },
            getUploadUrl: function() {
                return this.getWebAppContextUrl() + 'upload';
            },
            getRiskyContentCreationUrl: function() {
                return this.getWebAppContextUrl() + service.getUrl('riskyContent');
            },
            getRiskyContentStatusUrl: function(requestId) {
                return this.getWebAppContextUrl() + service.getUrl('riskyContent') + '/' + requestId;
            },
            getRiskyContentFeedbackUrl: function() {
                return this.getWebAppContextUrl() + service.getUrl('riskyContent') + '/feedback';
            },
            getWebAppContextUrl() {
                return service.getBaseUrl() + service.getServerApiContext();
            }
        };

        return service;
    }

})();
